var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_551_10935",
    transform: "translate(-0.137255 -0.117647) scale(0.012549)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_551_10935",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABI5JREFUeNrsnUtS20AQhoWKbcrZZoVvgDgB5gQoJ8CcIGaXXcQuS3MD+QbmBJgTIN/AXmWLKwcg09RPBVLE6DEz6tH8XTUFC7DG/alfo57RwdPTU0LRIylVQCAUAiEQCoEQCIVACITiWQ5DnPSX778n+HWM8a9UZjzK+PXzUxXSdzvQXqlD+TIyjKMWH7MFJBlLzZBUAjEQpuZHDhAjB5fYCRjAWRLI+xDE9RQAMfJ4aYFTmjE3cDbRA4FLEhCnCu6LW4BZRQcEFlEqAfEemFkfFuMdiAHxGRbxLYCk59pAKQYLBO6pbJkp9SWSoeW+MrPUIwy50+4Cg5Fgvg9m/rNBWAhclFjF+QAK6QViy2OQQABDMpbjAa1urKU+cgUldQhDqurNwGAk+D4r3GxhAAGMlecCbxBQrLssTLIKMHircF+pAxirSGA4sRTbLqscYMyoA2WuDgjy9PMkTrnACrWOGIIg/pDELTvEk0qDhZQJZWRDD50tBEsiPwJQmKxJLTGqfZkRgrRYvbihi4bXuTKfPe8FCJbQK+X1hoAojJJKTzebuK5x21S4q8sqlMOQtaesDYyOrqu1haQdreNCMwwDYupyIfCDrGvs20IKxTDuBUbPcyi8AQnAOqYK5pC3qeDTgL/wPle1UZIGTwnE4jKGBZk5B4KqXOvi4VZZV+IR9FVbDgdmHauGcVCsyfX6W45azZnLyhUD2dSE8fLMxsdiaCN9NQKCu0rzs46qgZX7KmiPm2RbTS1kkuiWukVg5nleE1dAsmQYMvZ8vYxAdAktRJk4iyEj6rZdYLcOpGmBQ2knqQuzo7x7Q09sA6F4kJC2RUuX4EeLdXULw1lNi78jkD1Fn629f3UXII2bUR1D6PMJhFkWpUV1Xdfl2gZSkZH7uJU2+MBHWog+l7WOCIjNQvjeFZBNREBs7nPZuAISRRxxsHewtt6aFoZSmPXV6X5qFPVRZ/hZneLRfI78jc8zVtw0OfR5Sk7AsmuitzZ1yD113NirOC0Ml9SxO30RSOhA0MhMt1VPbpsW1G3Xskrq2o2eWgHBFrEt9b1Xtm1OPE190o9Mijb/1AWIdI7vqPf/WkfpFQiCVUHd27OOrhaSYIM8Y8lbWXfZhm3jieGUDN5Ip8MyOwPBOs0NOTzLTdf1PlvP1Au6rueHd51jqhUgCPB5xDAk27RyaoS1rhM8xL+MNW7Y2v1rtQ0I2UVs8eTa5uE21vuyzOQky1hEAmNh+7B+J41yOPhlEQEM6ym/s87FgUNZuDptyGkrKSZ9PTAYVy6PfnLe2wsfe5mEvxAp8//a5TxFFUBeZV+TJNzOR5l35uONbt663yVPNyML0IVJWpv5OoPL+3YEuLCTRP9zeZnfie93UPWypQ1V7QTHc8sX1nSgzRaVdy/dNb1u2JHYYsYYQX+twCIuZT59vv1TxaZPBP0ShxNIpe/rbZ8vr2CdazmJTtUuXCjlOcc3cPLk7/twbbu0EhDUNf2pf1s04Ihby16Nl7PZ/7Wis9AbwoMAEpNwFy6BUAiEQCgEQiAUAiEQCoEQCEWT/BFgAJ36pIpXi6OoAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.bdb91688f19827c9cb0f66f90a712c1c.svg";
export { ForwardRef as ReactComponent };